<template>
    <div v-if="config" :key="refreshKey">
        <setting-card
            v-bind="binds"
            v-model:active="config.documentFromMail"
            :dialogBind="dialogBind"
            :closeOnValid="false"
            :hideMoreVert="true"
            :hidePrevious="true"
            @updateProfile="onClickValidBtbDialog()"
            @close="resetDialog()"
            @previous="resetStep()"
        >
            <v-row no-gutters>
                <v-col cols="12" class="pb-2">
                    bobbee va lire les mails reçus à ces adresses pour récupérer les factures
                </v-col>
                <v-col cols="12">
                    <v-window v-model="step" style="min-width: 600px">
                        <v-window-item :value="0">
                            <template v-if="config.documentFromMailConfig.users.length">
                                <div
                                    v-for="(user, i) in config.documentFromMailConfig.users"
                                    :key="i"
                                >
                                    <v-list-item
                                        v-if="!!user.forMyCompany === forMyCompany"
                                        class="mb-2 oss-list-item"
                                        :title="user.email"
                                    >
                                        <template v-slot:append class="my-0">
                                            <v-row no-gutters>
                                                <v-col class="d-flex flex-grow-0 flex-shrink-1">
                                                    <v-btn-icon
                                                        icon="$oss-edit"
                                                        size="small"
                                                        @click="(step = 2), (index = i)"
                                                    />
                                                </v-col>
                                                <v-col class="d-flex flex-grow-0 flex-shrink-1">
                                                    <v-btn-trash
                                                        size="small"
                                                        @click="removeEmail(i)"
                                                    />
                                                </v-col>
                                            </v-row>
                                        </template>
                                    </v-list-item>
                                </div>
                            </template>
                        </v-window-item>
                        <v-window-item :value="1">
                            <SettingsRegisterMail
                                ref="settingsRegisterMail"
                                v-if="step === 1"
                                :config="config"
                                :profileId="profileId"
                                :companyId="companyId"
                                :mailUsage="'documentFromMail'"
                                :forMyCompany="forMyCompany"
                                @onUpdate="
                                    refresh();
                                    step = 0;
                                "
                                @currentStep="settingsRegisterMailStep = $event"
                                @displayValid="manageValidForm"
                            />
                        </v-window-item>
                        <v-window-item :value="2">
                            <SettingUpdateMailPassword
                                ref="settingUpdateMailPassword"
                                :config="config"
                                :profileId="profileId"
                                :mailUsage="'documentFromMail'"
                                :index="index"
                                @onUpdate="refresh()"
                                @displayValid="displayValid = $event"
                            />
                        </v-window-item>
                    </v-window>
                </v-col>
            </v-row>
        </setting-card>
    </div>
</template>

<script lang="ts">
import SettingCard from "../SettingCard.vue";
import SettingsRegisterMail from "./components/SettingsRegisterMail.vue";
import SettingUpdateMailPassword from "./SettingUpdateMailPassword.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        SettingCard,
        SettingsRegisterMail,
        SettingUpdateMailPassword,
    },
    emits: ["updateProfile", "onUpdate"],
})
export class SettingDocumentFromMail extends Vue {
    @Prop({ default: null }) config!: any;
    @Prop({ default: null }) companyId!: string;
    @Prop({ default: null }) profileId!: string;
    @Prop({ default: false }) forMyCompany: boolean;

    step = 0;
    settingsRegisterMailStep = "default";
    refreshKey = 0;
    index = -1;
    displayValid = false;

    get binds() {
        return {
            title: "Récupération automatique des factures d'achat",
            partnerName: "bobbee",
            text: "Récupération des factures d'achat à partir de boîtes mails communiquées aux clients",
        };
    }

    get validTitle() {
        if (this.step === 0) {
            return "Ajouter une nouvelle adresse mail";
        }
        if (this.settingsRegisterMailStep === "notGmailVue") {
            return "Ajouter";
        }
        if (this.step === 2) {
            return "Modifier le mot de passe";
        }
    }

    get dialogBind() {
        return {
            title: "Récupération automatique des factures",
            "valid-title": this.validTitle,
            validDisabled: this.step !== 0 && !this.displayValid,
            "hide-valid":
                [1].includes(this.step) && ["default"].includes(this.settingsRegisterMailStep), // hide valid button if the step is in this array
            "previous-display": this.step !== 0,
        };
    }

    async removeEmail(i: number) {
        if (i >= 0 && i < this.config.documentFromMailConfig.users.length) {
            this.config.documentFromMailConfig.users.splice(i, 1);
            this.updateProfile();
        }
    }

    updateProfile() {
        if (this.config.documentFromMailConfig.users.length) {
            this.config.documentFromMail = true;
        } else {
            this.config.documentFromMail = false;
        }
        this.$emit("updateProfile");
    }

    async onClickValidBtbDialog() {
        switch (this.step) {
            case 0:
                {
                    this.step = 1;
                }
                break;
            case 1:
                {
                    debugger;
                    // @ts-ignore
                    if (this.$refs.settingsRegisterMail.testAndCreationFromOutside()) {
                        await this.updateProfile();
                        this.refreshKey++;
                        this.step = 0;
                    }
                }
                break;
            case 2:
                {
                    // @ts-ignore
                    if (this.$refs.settingUpdateMailPassword.testAndModificationFromOutside()) {
                        await this.updateProfile();
                        this.refreshKey++;
                        this.step = 0;
                    }
                }
                break;
        }
    }

    resetDialog() {
        // if(this.config.documentFromMailConfig.users.length === 0) {
        //     this.config.documentFromMail = false
        //     this.updateProfile()
        // }
        this.step = 0;
        // this.ueUpdatePassword = false
        this.refreshKey++;
    }

    validCategory = ["ALL", "MAIL"];

    searchCondition(search: string) {
        return (
            this.binds.title.toLowerCase().includes(search.toLowerCase()) ||
            this.binds.partnerName.toLowerCase().includes(search.toLowerCase()) ||
            this.binds.text.toLowerCase().includes(search.toLowerCase())
        );
    }

    displayCondition(
        search = "",
        tab: "ALL" | "BANK" | "MAIL" | "INVOICE" | "PAYEMENT" | "OTHER" = "ALL",
    ) {
        if (search) {
            return this.validCategory.includes(tab) && this.searchCondition(search);
        }
        return this.validCategory.includes(tab);
    }

    refresh() {
        this.$emit("onUpdate");
    }

    resetStep() {
        this.step = 0;
        this.settingsRegisterMailStep = "default";
    }

    manageValidForm(e) {
        this.displayValid = e;
        // console.log(this.dialogBind, "displayValid: ", this.displayValid)
    }
}

export default toNative(SettingDocumentFromMail);
</script>
